import { Coins } from "lucide-react";

// Stakes are shown as "1/2" with a chip icon — play money, no dollar sign.
export const Stakes = ({ sb, bb, className = "", raw = false }) => (
  <span className={`inline-flex items-center gap-1 font-mono ${className}`} data-testid="stakes-label">
    <Coins className="w-3.5 h-3.5 text-amber-400" /> {raw ? `${sb}/${bb}` : `${fmtStake(sb)}/${fmtStake(bb)}`}
  </span>
);

export const fmtStake = (n) => (n >= 1000 ? `${(n / 1000).toLocaleString(undefined, { maximumFractionDigits: 1 })}K` : String(n));
export const fmtNum = (n) => Number(n || 0).toLocaleString();
export const fmtWhen = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—");

export const Card = ({ title, children, className = "", testId }) => (
  <section data-testid={testId} className={`gold-card rounded-2xl p-5 rise ${className}`}>
    {title && <div className="text-[11px] uppercase tracking-[0.25em] gold-text mb-4">{title}</div>}
    {children}
  </section>
);

export const Stat = ({ label, value, sub, testId }) => (
  <div className="glass rounded-xl px-4 py-3" data-testid={testId}>
    <div className="text-[10px] uppercase tracking-[0.25em] text-slate-400">{label}</div>
    <div className="font-mono text-2xl text-amber-100 mt-1">{value}</div>
    {sub && <div className="text-[11px] text-slate-400 mt-0.5">{sub}</div>}
  </div>
);

export const Field = ({ label, children, hint }) => (
  <label className="flex flex-col gap-1 text-xs text-slate-300">
    <span className="text-[10px] uppercase tracking-[0.2em] text-slate-400">{label}</span>
    {children}
    {hint && <span className="text-[10px] text-slate-500">{hint}</span>}
  </label>
);

export const inputCls = "bg-black/40 border border-white/10 rounded-md px-3 py-2 text-sm text-amber-50 focus:border-amber-400/60 outline-none";
